import React, { createContext, useContext, useState, useCallback } from 'react';
import { LoanOption } from '../../../types';
import { LoanContextType } from '../types/loan.types';

const LoanContext = createContext<LoanContextType | undefined>(undefined);

export const LoanProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedLoanOption, setSelectedLoanOption] = useState<LoanOption | null>(null);

  const selectLoanOption = useCallback((option: LoanOption): void => {
    setSelectedLoanOption(option);
  }, []);

  const clearLoanOption = useCallback(() => {
    setSelectedLoanOption(null);
  }, []);

  const value: LoanContextType = {
    selectedLoanOption,
    selectLoanOption,
    clearLoanOption,
    hasSelectedOption: selectedLoanOption !== null
  };

  return <LoanContext.Provider value={value}>{children}</LoanContext.Provider>;
};

export const useLoan = (): LoanContextType => {
  const context = useContext(LoanContext);
  if (!context) {
    throw new Error('useLoan must be used within a LoanProvider');
  }
  return context;
};
